import { type ReactNode } from 'react';
import styled from 'styled-components';
import { InfoPopover } from '../popover/InfoPopover.tsx';

/**
 * Limita la larghezza del contenuto: con descrizioni lunghe il popover si
 * allargava troppo. Il popover si dimensiona sul contenuto, quindi il
 * max-width sul wrapper basta a contenerlo (il testo va a capo).
 */
const DescriptionPopoverContent = styled.div`
  max-width: 320px;
`;

export interface IConfigurationCardDescriptionPopoverProps {
  description: ReactNode;
}

/**
 * Popover ⓘ usato in modalità densa al posto della descrizione a riga piena
 * nelle `ConfigurationCard` / `ConfigurationSubCard`. Wrappa il contenuto con
 * un max-width dedicato senza alterare il comportamento generico di
 * `InfoPopover`.
 */
export function ConfigurationCardDescriptionPopover(
  props: Readonly<IConfigurationCardDescriptionPopoverProps>,
) {
  return (
    <InfoPopover
      // Pass-through dei click esterni (focus-trap `allowOutsideClick`): senza,
      // il trap "mangia" il click che chiude il popover e un click sull'header
      // della card sembra perso invece di fare il toggle del collapse.
      allowPortalClicks
      content={
        <DescriptionPopoverContent>
          {props.description}
        </DescriptionPopoverContent>
      }
    />
  );
}
